// src/features/inventory/hooks/useStockLocations.js
import { useState, useCallback } from 'react';
import { stockLocationsAPI } from '../services/stockLocations';
import { useApi } from '../../../hooks/api/useApi';

export function useStockLocations() {
  const [stockLocations, setStockLocations] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchStockLocations = useCallback(async () => {
    const result = await execute(() => stockLocationsAPI.getStockLocations());
    if (result.success) {
      setStockLocations(result.data.data || []);
    }
    return result;
  }, [execute]);

  const createStockLocation = useCallback(async ({ name, description = null }) => {
    const result = await execute(() =>
      stockLocationsAPI.createStockLocation({ name, description })
    );
    if (result.success) {
      setStockLocations(prev => [...prev, result.data.data]);
    }
    return result;
  }, [execute]);

  const updateStockLocation = useCallback(async (stockLocationId, { name, description, active }) => {
    const result = await execute(() =>
      stockLocationsAPI.updateStockLocation(stockLocationId, { name, description, active })
    );
    if (result.success) {
      setStockLocations(prev =>
        prev.map(loc => loc.stock_location_id === stockLocationId ? result.data.data : loc)
      );
    }
    return result;
  }, [execute]);

  const deleteStockLocation = useCallback(async (stockLocationId) => {
    const result = await execute(() => stockLocationsAPI.deleteStockLocation(stockLocationId));
    if (result.success) {
      setStockLocations(prev => prev.filter(loc => loc.stock_location_id !== stockLocationId));
    }
    return result;
  }, [execute]);

  return {
    stockLocations,
    loading,
    error,
    clearError,
    fetchStockLocations,
    createStockLocation,
    updateStockLocation,
    deleteStockLocation,
  };
}
